import Provider from './providers';
import AppRoutes from './Routes';

const App = () => (
  <Provider>
    <AppRoutes />
  </Provider>
);

export default App;
